import React from 'react'
import Typography from '@mui/material/Typography'
import GSSVG from 'smartstream-widgets/controls/GSSVG'

import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme';

type Props = {
  classes: {
    [K in string]: string
  },
  controlText?: string,
  currentIndex: number,
  enableAutoScroll?: boolean,
  iconViewBox?: string,
  isAdvertShowing: boolean,
  isButtonActive: boolean,
  isPrevious?: boolean,
  onClick: ((arg0: any) => void),
  svgIconLinkHref: string
}

const styles = (theme: Theme) =>  createStyles({
  advertSlideButton: {
    opacity: 0,
    '&$enableAutoScroll': {
      background: 'rgba(255,255,255,0.7)',
      opacity: 1,
      padding: 8,
      flex: 0,
      borderRadius: '50%'
    },
  },
  carouselButton: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    outline: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    pointerEvents: 'auto',
    transition: 'opacity .3s',
    '&:disabled': {
      cursor: 'auto',
      opacity: '0'
    }
  },
  carouselButtonLeft: {
    flexDirection: 'row-reverse'
  },
  carouselButtonRight: {},
  controlCaptions: {
    fontSize: theme.typography.fontSize
  },
  controlIconsCss: {
    borderBottom: '10px solid transparent',
    borderTop: '10px solid transparent',
    height: 0,
    margin: `0px ${theme.spacing(1)}`,
    width: 0
  },
  controlIconsSvg: {},
  enableAutoScroll: {},
  leftControlCaption: {},
  leftControlIconSvg: {},
  leftArrowCss: {
    borderRight: `12px solid ${theme.palette.primary.main}`
  },
  rightControlCaption: {},
  rightControlIconSvg: {},
  rightArrowCss: {
    borderLeft: `12px solid ${theme.palette.primary.main}`
  }
})

function CarouselArrow (props: Props) {
  const {
    classes,
    controlText,
    currentIndex,
    enableAutoScroll = false,
    iconViewBox,
    isButtonActive,
    isPrevious,
    onClick,
    svgIconLinkHref,
    isAdvertShowing
  } = props

  const buttonDirectionClass = isPrevious ? classes.carouselButtonLeft : classes.carouselButtonRight
  const captionDirectionClass = isPrevious ? classes.leftControlCaption : classes.rightControlCaption
  const iconDirectionClass = isPrevious ? classes.leftControlIconSvg : classes.rightControlIconSvg
  const isIconControlActive = !!(svgIconLinkHref && iconViewBox)
  const advertClass = isAdvertShowing ? classes.advertSlideButton : ''
  const nextIndex = isPrevious ? currentIndex - 1 : currentIndex + 1
  const svgIcon = (
    <GSSVG
      className={`${classes.controlIconsSvg} ${iconDirectionClass}`}
      viewBox={iconViewBox}
      xlinkHref={svgIconLinkHref} />
  )
  const cssIcon = (<div className={`${classes.controlIconsCss} ${isPrevious ? classes.leftArrowCss : classes.rightArrowCss}`} data-testid="arrow-css-icon" />)
  return (
    <button
      data-testid='carousel-arrow-button'
      data-ht-category='carousel'
      data-ht-action={`slide change to ${nextIndex}`}
      data-ht-label={isPrevious ? 'prev' : 'next'}
      className={`${classes.carouselButton} ${buttonDirectionClass} ${advertClass} ${enableAutoScroll ? classes.enableAutoScroll : ''}`}
      disabled={!isButtonActive}
      onClick={() => { if (isButtonActive && onClick) onClick(nextIndex) }}
    >
      {controlText && !isAdvertShowing &&
      <Typography className={`${classes.controlCaptions} ${captionDirectionClass}`} component='span' data-testid="arrow-label">
        {controlText}
      </Typography>}
      {isIconControlActive ? svgIcon : cssIcon}
    </button>
  )
}

export default withStyles(styles, {name: 'CarouselArrow', defaultTheme: getDefaultTheme})(CarouselArrow)
